var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44808 13.9907C1.17031 14.0463 0.937667 13.9768 0.750167 13.7824C0.562667 13.5879 0.496695 13.3518 0.552251 13.0741L1.32308 9.36572L5.15642 13.2199L1.44808 13.9907ZM5.15642 13.2199L1.32308 9.36572L10.2814 0.428223C10.5731 0.136556 10.9238 -0.00927734 11.3335 -0.00927734C11.7432 -0.00927734 12.0939 0.136556 12.3856 0.428223L14.1148 2.13656C14.4064 2.42822 14.5523 2.78239 14.5523 3.19906C14.5523 3.61572 14.4064 3.96989 14.1148 4.26156L5.15642 13.2199ZM11.3231 1.49072L3.19808 9.63656L4.90642 11.3449L13.0523 3.21989L11.3231 1.49072Z",
    fill: "#EE750A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.a829b595f702d930403a3f02c9f488c8.svg";
export { ForwardRef as ReactComponent };